import { useEffect, useState } from 'react';
import { loggedIn } from "../components/common";
import { subCachestoresBreadcrumbs } from "../components/common";

import { useNavigate } from 'react-router-dom';
import { NewCachestoreForm } from "../components/new-cachestore-form";

import {
  BreadcrumbGroup,
} from '@cloudscape-design/components';

import '../css/base.scss';

const Breadcrumbs = ({navigate, item}) => (
  <BreadcrumbGroup
    onFollow={event => {
      event.preventDefault();
      navigate(event.detail.href);
    }}
    items={subCachestoresBreadcrumbs(item)}
    expandAriaLabel="Show path"
    ariaLabel="Breadcrumbs" />
)

export default function NewCachestore({ state }) {
  const navigate = useNavigate();
  if (!loggedIn()) {
    return null;
  }
  useEffect(() => {
    state.activeHref.setHref("/cachestores");
    state.breadCrumbs.setCrumbs(
      <Breadcrumbs navigate={navigate} item="Create Cache Store" />
    )
    state.maxContentWidth.setWidth(Number.MAX_VALUE);
    state.contentType.setType("default");
  }, []);
  return (
      <NewCachestoreForm resource="Cache Store" url="cachehosts" flashbar={state.flashBar}/>
  );
}
